// Sold out today
furbo.sold={};
furbo.sold.generate=function(){
  var counts=[75,68,65,81,63,77,70,69,72,70,66,67,61,78];
  var now=new Date();
  var index=(now.getMonth()+now.getDate())%counts.length;
  var soldCount=document.getElementById("sold-count");
  if(soldCount){
  	soldCount.textContent=counts[index];
  }
};

// Review
furbo.review={};
furbo.review.readmore=function(){
  var readmore=document.getElementById("read-more");
  readmore.style.display="none";
  readmore.previousSibling.style.display="none";
  var reviewmore=document.getElementById("review-more");
  reviewmore.style.display="block";
};

// Popup media feature
furbo.popup={};
furbo.popup.showVideo=function(code){
  var mask=document.getElementById("media-mask");
  mask.style.display="block";
  var content=document.getElementById("media-content");
  content.innerHTML=code;
  content.style.display="block";
  document.getElementById("media-close").style.display="block";
  furbo.popup.resize();
};
furbo.popup.resize=function(){
  var content=document.getElementById("media-content");
  if(content.style.display=="block"){
    var width=content.offsetWidth*0.8>1280?1280:content.offsetWidth*0.8;
    var height=720*width/1280;
    content.firstChild.width=width;
    content.firstChild.height=height;
  }
};
furbo.popup.hide=function(){
  document.getElementById("media-mask").style.display="none";
  document.getElementById("media-close").style.display="none";
  var content=document.getElementById("media-content");
  content.style.display="none";
  content.innerHTML="";
};

// Checkout
furbo.cart={};
furbo.cart.checkout=function(){
  /*
  f=document.cartForm;
  window.location="/cart/"+f.id.value+":"+f.quantity.value;
  */
  window.location="https://shopuk.furbo.com/products/furbo-dog-camera";
};
// Initialize
window.addEventListener("load", function(){
  document.getElementById("media-content").addEventListener("click", furbo.popup.hide);
  document.getElementById("media-close").addEventListener("click", furbo.popup.hide);
  showDetails(0);
});


//Furbo countdown function
var countDownDate = new Date(2018,05-1,14,00,00);
// Update the count down every 1 second
// var x = setInterval(function() {
//   countdown();
// }, 1000);

//zero means display:none;
function showDetails(id){
  var x = document.getElementsByClassName("feature-description");
  var y = document.getElementById("feature-sign-img-"+id);
  console.log("feature-sign-img-"+id);
  console.log(x[id].style.display);
  if(x[id].style.display == "block"){
        x[id].style.display = "none";
    y.src="https://cdn.shopify.com/s/files/1/1362/5949/files/expand.png?7595341372435851870";

    
  }else{
    x[id].style.display = "block";
    y.src="https://cdn.shopify.com/s/files/1/1362/5949/files/hide.png?7595341372435851870";
  }
} 

function countdown(){
	// Get todays date and time
  var now = new Date().getTime();

  // Find the distance between now an the count down date
  var distance = countDownDate - now;

  // Time calculations for days, hours, minutes and seconds
  var days = Math.floor(distance / (1000 * 60 * 60 * 24));
  var hours = Math.floor((distance % (1000 * 60 * 60 * 24 )) / (1000 * 60 * 60));
  var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
  var seconds = Math.floor((distance % (1000 * 60)) / 1000);

  // Display the result in the element with id="demo"
  if(window.innerWidth>800){
  document.getElementById("CountDown-pc").innerHTML =  "<table align=\"left\"><tr align=\"center\"><td><span style=\"font-size:32px;color:#ffd300\">"
  + days + ":</span><br><span style=\"font-size:12px\">DAYS</span></td><td><span style=\"font-size:32px;color:#ffd300\">"
  + hours + ":</span><br><span style=\"font-size:12px\">HOURS</span></td><td><span style=\"font-size:32px;color:#ffd300\">"
  + minutes + ":</span><br><span style=\"font-size:12px\">MINS</span></td><td><span style=\"font-size:32px;color:#ffd300\">"
  + seconds + "</span><br><span style=\"font-size:12px\">SECS</span></td></tr></table>";
    }
  else
  {
  document.getElementById("CountDown-mobile").innerHTML =  "<table align=\"left\"><tr align=\"center\"><td><span style=\"font-size:24px;color:#ffd300\">"
  + days + "</span><span style=\"font-size:14px\">DAYS&nbsp;</span></td><td><span style=\"font-size:24px;color:#ffd300\">"
  + hours + "</span><span style=\"font-size:14px\">HOURS&nbsp;</span></td><td><span style=\"font-size:24px;color:#ffd300\">"
  + minutes + "</span><span style=\"font-size:14px\">MINS&nbsp;</span></td><td><span style=\"font-size:24px;color:#ffd300\">"
  + seconds + "</span><span style=\"font-size:14px\">SECS&nbsp;</span></td></tr></table>";    
  }
  // If the count down is finished, write some text 
  if (distance < 0) {
    clearInterval(x);
    document.getElementById("CountDown").innerHTML = "-";
  }
}